import React, { useEffect } from 'react'
import { withUserStore } from '../../contexts/UserStore'

const Logout = (props) => {
  useEffect(() => {
    props.userStore.logout()
  }, []);

  return (<></>)
}

export default withUserStore(Logout)